export default __webpack_public_path__ + "static/media/WD-619 1D wired laser barcode scanner.c56e1671.jpg";